import { render, staticRenderFns } from "./setDefaultValuesModal.vue?vue&type=template&id=6b6e302a"
import script from "./setDefaultValuesModal.js?vue&type=script&lang=js&external"
export * from "./setDefaultValuesModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports